// extracted by mini-css-extract-plugin
export default {"paymentElement":"PaymentFormSkeleton_paymentElement__2ZsPQ","button":"PaymentFormSkeleton_button__UJ6Ub"};